// Opens the Beamer sidepanel. Falls back to the public changelog page when
// Beamer's SDK is unavailable — most commonly because tracker-blocking
// browsers (Arc, Dia, Brave, uBlock) blocked the requests Beamer needs to
// initialize, or because Beamer's backend was degraded.
//
// Each fallback fires a Heap event so we can monitor how often this happens
// without users having to report it. Heap itself may be blocked by the same
// trackers, so the metric undercounts blocked-tracker users.
import { SfLog } from '@app/adapters/logger'

type FallbackReason = 'sdk_unavailable' | 'show_threw'

const openFallback = (
  reason: FallbackReason,
  fallbackUrl: string | undefined
): void => {
  window.heap?.track('beamer-sidepanel-fallback-opened', { reason })
  if (fallbackUrl) window.open(fallbackUrl, '_blank', 'noopener,noreferrer')
}

export function openBeamerPanel(fallbackUrl: string | undefined): void {
  if (!window.Beamer) {
    openFallback('sdk_unavailable', fallbackUrl)
    return
  }

  try {
    window.Beamer.show()
  } catch (error) {
    SfLog.warn('Beamer.show() threw, opening fallback', { extra: { error } })
    openFallback('show_threw', fallbackUrl)
  }
}
